module.exports = __webpack_public_path__ + "media/reskin-images/icon--mini-video-1b2f8049.svg";